import React from "react";
// used for making the prop types of this component
import PropTypes from "prop-types";

// core components
import Button from "components/CustomButtons/Button.js";
import CustomDeleteButton from "../CustomDeleteButton/CustomDeleteButton.js";

import defaultImage from "assets/img/image_placeholder.jpg";
import defaultAvatar from "assets/img/placeholder.jpg";

export default function ImageUpload(props) {
  const { file, setFile, imagePreviewUrl, setImagePreviewUrl,setImageCode } = props;

  let fileInput = React.createRef();
  const handleImageChange = (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      setFile(file);
      setImagePreviewUrl(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };
  // eslint-disable-next-line
  const handleSubmit = (e) => {
    e.preventDefault();
    // file is the file/image uploaded
    // in this function you can save the image (file) on form submit
    // you have to call it yourself
  };
  const handleClick = () => {
    fileInput.current.click();
  };
  const handleRemove = () => {
    setImageCode(null);
    setFile(null);
    setImagePreviewUrl(props.avatar ? defaultAvatar : defaultImage);
    fileInput.current.value = null;
  };
  let { avatar, addButtonProps, changeButtonProps, removeButtonProps } = props;
  return (
    <div className="fileinput" style={{marginTop:"9px"}}>
      <input type="file" onChange={handleImageChange} ref={fileInput} />
      <div className={"thumbnail" + (avatar ? " img-circle" : "")} style={{width: "250px",height: "150px"}}>
        <img src={imagePreviewUrl} alt="..." />
      </div>
      <div>
        {!props.disabled ? 
        imagePreviewUrl === null ? (
          <Button 
          style={{
            color: "#FFFFFF",
            backgroundColor: "#91C73C",
            fontWeight: "normal",
            fontWeight: "bold",
            height: "40px",
            fontSize: "0.75rem",
            padding: "5px 15px",
            marginRight: "5px",
            marginBottom: "0px",
            marginTop: "0px",
            fontFamily: '"Source Sans Pro",sans-serif',
          }}
          onClick={() => handleClick()}>
            Ajouter
        </Button>
        ) : (
          <span>
            <Button 
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "5px",
                marginBottom: "0px",
                marginTop: "0px",
                fontFamily: '"Source Sans Pro",sans-serif',
              }}
              onClick={() => handleClick()}>
                Modifier
            </Button>
            {avatar ? <br /> : null}
            <CustomDeleteButton
              size="40px"
              deleteTitle={"Suppression de l'image"}
              deleteSubTitle={
                "Êtes-vous sûr de vouloir supprimer l'image?"
              }
              handleSupprimer={handleRemove}
            >
              Supprimer
            </CustomDeleteButton>
          </span>
        )
       : <></>}
      </div>
    </div>
  );
}

ImageUpload.propTypes = {
  avatar: PropTypes.bool,
  addButtonProps: PropTypes.object,
  changeButtonProps: PropTypes.object,
  removeButtonProps: PropTypes.object,
};
